import useTranslation from 'next-translate/useTranslation';
import TeaserGrid from '#components/lists/teaser-grid/TeaserGrid';
import TabNavigator, {
  ITabItem,
} from '#components/navigation/tab-navigator/TabNavigator';
import Button from '#components/controls/buttons/button/Button';
import CircularProgress from '#components/feedback/circular-progress/CircularProgress';
import IllustratedLayout from '#components/layout/IllustratedLayout';
import { Teaser } from '#types/generated/graphql-types';
import { ApolloError } from '@apollo/client';

type Props = {
  options: ITabItem[];
  selectedOption?: ITabItem;
  items: Teaser[];
  loading: boolean;
  hasMore: boolean;
  error: ApolloError | undefined;
  onLoadMore: () => void;
  onSelectOption: (item) => void;
};

const PageableGrid = ({
  items,
  hasMore,
  loading,
  options,
  error,
  selectedOption,
  onLoadMore,
  onSelectOption,
}: Props) => {
  const { t } = useTranslation();
  const handleTabChange = (item) => {
    onSelectOption?.(item);
  };

  const loadMore = () => {
    onLoadMore?.();
  };

  return (
    <>
      {(!!selectedOption || items.length > 0) && (
        <TabNavigator
          items={options}
          onChange={handleTabChange}
          selectedOption={selectedOption}
        />
      )}

      {loading && !items?.length && (
        <div className="tw-flex tw-items-center tw-justify-center tw-p-24">
          <CircularProgress size={30} color="#fff" />
        </div>
      )}

      <TeaserGrid
        items={items}
        teaserGridContainerProps={{ classes: 'tw-pt-12' }}
      />
      {hasMore && items.length > 0 && (
        <div
          className="tw-flex tw-mt-8 tw-justify-center"
          data-testid="load-more"
        >
          <Button
            disabled={loading}
            text={t('buttonLoadMore')}
            onClick={loadMore}
            startIcon={
              loading && !error ? <CircularProgress size={20} /> : null
            }
          />
        </div>
      )}

      {!loading && items.length === 0 && (
        <IllustratedLayout
          verticalAlignContent="center"
          image="/static/images/img/snorri-search-failure@2x.png"
          content={t('searchFailureDescription')}
          title={t('searchFailureTitle')}
        />
      )}
    </>
  );
};

export default PageableGrid;
